import { AuthenticationContext, adalFetch, withAdalLogin } from 'react-adal';
import { UserInfo } from '../../components/Login/common/defaults';
import AdalConfig from "./AdalEnvConfig";



export const AuthContext = new AuthenticationContext(AdalConfig);

export const adalApiFetch = (fetch, url, options) =>
  adalFetch(AuthContext, AdalConfig.endpoints.api, fetch, url, options);

export const withAdalLoginApi = withAdalLogin(
  AuthContext,
  AdalConfig.endpoints.api
);

export const getToken = () => {
  let token = AuthContext.getCachedToken(AdalConfig.clientId);
  if (!token) {
    const user = JSON.parse(sessionStorage.getItem('sessionUser'));
    token = user.token;
  }
  return token;
};
